<script>
import firebase from "firebase/compat/app";
import LoginComponent from "@/components/Auth/Login";
import SignupComponent from "@/components/Auth/Signup";
import Divider from "../../components/base/Divider.vue";
export default {
  name: "HomeAppBar",

  components: {
    LoginComponent,
    SignupComponent,
    HomeDrawer: () => import("./Drawer"),
    Feedback: () => import("../../components/Feedback"),
    Loader: () => import("@/components/Loader.vue"),
  },

  data: () => ({
    loading: false,
    sellDialog: false,
    listingDialog: false,
    snackbar: false,
    text: "",
    successDialog: false,
    sellComment: "",
    priority: true,
    authUser: null,
    userDataFromDB: null,
    redirect: true,
    loginDialog: false,
    signupDialog: false,
    hasColor: false,
    drawer: null,
    continueAddPriorityAfterLogin: false,
    changeBackgroundColor: false,
    changeBackgroundColor1: false,
    changeBackgroundColor2: false,
    items: ["Home", "About", "Contact"],
    drops: [
      { title: "Sign Up" },
      { title: "Login" },
      // { title: "Click Me" },
      // { title: "Click Me 2" }
    ],
  }),
  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        if (this.shouldRedirect) {
          this.$router.push("/dashboard");
          this.$emit("loggedIn");
        } else if (this.addItem) {
          this.welcomeDialog = true;
          this.$emit("loggedIn");
          this.$router.push({ name: "Onboarding", params: { addItem: true } });
        } else {
          this.$emit("loggedIn");
        }
      }
      if (value != null && this.continueAddPriorityAfterLogin) {
        this.getPriorityAccess();
      }
    },
  },
  computed: {
    inbox() {
      let chats = this.$store.getters.loadedRooms;
      let chatCount = 0;
      for (let i = 0; i < chats.length; i++) {
        if (chats[i].lastMessage.senderId != this.$store.getters.user.id) {
          chatCount = chatCount + chats[i].unreadCount;
        }
      }
      return chatCount;
    },
    user() {
      return this.$store.state.user;
    },
    avatar() {
      return this.$store.state.user.avatar;
    },
    color() {
      return this.hasColor ? "rgb(0,0,0,0.3)" : "transparent";
    },
    height() {
      let height = [{ height: "80px" }];
      if (this.userIsAuthenticated) {
        height = [{ height: "130px" }];
      }
    },
    size() {
      const size = { xs: "x-small", sm: "medium", lg: "large", xl: "large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
    menuItems() {
      let menuItems = [
        {
          icon: "fas fa-user-plus",
          title: "Sign up",

          outlined: "outlined",
        },
        {
          icon: "fas fa-unlock",
          title: "Login",
        },
      ];
      if (this.userIsAuthenticated) {
        menuItems = [
          {
            title: "Dashboard.",
            link: "/dashboard",
          },
        ];
      }
      return menuItems;
    },
    userIsAuthenticated() {
      return this.$store.getters.user;
    },
    userIsNotAuthenticated() {
      //return if user this.$store.getters.user is empty

      return this.$store.getters.user == null;
    },
  },

  created() {
    this.$root.$refs.AppBar = this;
    firebase.auth().onAuthStateChanged((user) => {
      this.authUser = user;
      if (user) {
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        firebase
          .firestore()
          .collection("users")
          .doc(user.uid)
          .get()
          .then((snap) => {
            this.userDataFromDB = snap.data();
            if (this.userDataFromDB && this.userDataFromDB.verified) {
              this.$emit("profileVerified", true);
            }
          });
      }
    });
    var vm = this;
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        vm.user = user;
        vm.name = firebase.auth().currentUser.displayName;
        vm.email = vm.user.email;
        vm.photoURL = vm.user.photoURL;
        vm.userId = vm.user.uid;
      }
    });
  },
  // watch: {
  //   user(value) {
  //     if (value !== null && value !== undefined) {
  //       if (this.shouldRedirect) {
  //         this.$router.push('/dashboard');
  //         this.$emit('loggedIn');
  //       } else if (this.addItem) {
  //         this.$emit('loggedIn');
  //       } else {
  //         this.$emit('loggedIn');
  //       }
  //     }
  //   },
  // },
  methods: {
    showToast(msg) {
      console.log("fire toast");
      this.snackbar = true;
      this.text = msg;
    },
    openListingDialog() {
      console.log("open listing dialog");
      this.listingDialog = true;
    },
    dashboard() {
      this.$router.push("/dashboard");
    },
    items() {
      this.$router.push("/search");
    },
    checkUserIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },

    getPriorityAccess() {
      console.log(this.priority, this.sellComment);
      if (!this.checkUserIsAuthenticated()) {
        // TODO
        this.redirect = false;
        this.signupDialog = true;
        this.continueAddPriorityAfterLogin = true;
      } else {
        this.$store
          .dispatch("savePriorityBuySell", this.sellComment)
          .then(() => {
            // this.showLoadingForCreateItem = false;
            // this.successDialog = true;
            console.log("success");
            this.successDialog = true;
          })
          .catch((err) => {
            //handle error
            // this.showLoadingForCreateItem = false;
            this.showToast("Error. Please try again.");
            console.log(err);
          });
      }
    },

    openSellModel() {
      this.listingDialog = false;
      this.sellDialog = true;
    },
    log() {
      console.log(this.user);
    },
    async toInbox() {
      this.loading = true;
      await this.$store
        .dispatch("loadRooms", this.$store.getters.user)
        .then((response) => {
          this.loading = false;
          this.$router.push("/inbox");
        });
    },

    onScroll() {
      this.hasColor = window.scrollY > 50;
    },
    onLogout() {
      firebase.auth().signOut();
      //setUser to null
      this.$store.commit("setUser", null);

      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },
  },
};
</script>
<template>
  <div>
    <v-img
      v-if="this.$route.name == 'Home 🏠'"
      :src="require('@/assets/Blob3.png')"
      :style="$vuetify.breakpoint.smAndDown ? '' : 'margin-left: 40vw;'"
      style="
        opacity: 0.8;
        z-index: 2;
        margin-top: 0px;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
      "
      :height="
        $vuetify.breakpoint.xs
          ? '90vh'
          : '' && $vuetify.breakpoint.smAndDown
          ? '140vh'
          : 'auto'
      "
      :width="$vuetify.breakpoint.smAndDown ? 'auto' : 'auto'"
    />
    <v-overlay opacity="0.8" v-if="loading">
      <Loader class="loading-page" />
    </v-overlay>
    <v-snackbar v-model="snackbar">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Got it!
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog
      v-model="successDialog"
      max-width="450px"
      transition="dialog-bottom-transition"
    >
      <template>
        <v-card style="border-radius: 12px !important" class="text-center pa-6">
          <v-card-title
            style="
              padding: 0px 0px !important;
              font-size: 1.5em !important;
              line-height: 1.43;
            "
            class="text-center black--text"
          >
            <!-- <v-icon
                                small
                                color="black"
                                @click="startDialog = false"
                                >mdi-close</v-icon
                              > -->
            <p class="ml-auto mr-auto">Woohoo!</p>
          </v-card-title>
          <v-divider></v-divider>
          <div class="grid">
            <v-img
              size="small"
              width="250px"
              height="250px"
              :src="require('@/assets/svgs/celebrate-1.svg')"
            ></v-img>
          </div>
          <v-card-text
            style="
              font-size: 16px !important;
              line-height: 20px !important;
              color: rgb(34, 34, 34) !important;
            "
          >
            Congrats on joining our early access list!
          </v-card-text>

          <v-col>
            <v-row class="mb-3">
              <v-btn
                block
                class="btn white--text"
                style="border-radius: 8px !important"
                @click="dashboard()"
                color="#8F9CF8"
              >
                Continue to dashboard
              </v-btn>
            </v-row>
            <v-row>
              <v-btn
                block
                class="mt-1 btn white--text"
                style="border-radius: 8px !important"
                to="/search"
                color="accent"
              >
                Browse items to rent
              </v-btn>
            </v-row>
          </v-col>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      v-model="listingDialog"
      max-width="450px"
      transition="dialog-bottom-transition"
    >
      <template>
        <v-card style="border-radius: 12px !important" class="text-center">
          <v-card-title
            style="
              padding: 0px 24px !important;
              font-size: 1.5rem !important;
              line-height: 1.43;
            "
            class="text-center black--text"
          >
            <p class="my-3 ml-auto mr-auto">List an Item</p>
          </v-card-title>
          <v-card-text
            style="
              font-size: 16px !important;
              line-height: 20px !important;
              color: rgb(34, 34, 34) !important;
            "
            class="mt-2 pb-0"
          >
            Whether its buying, selling or renting, Strapp has you covered!
            Choose whether you want to sell or rent out your new listing.
          </v-card-text>
          <div class="grid mb-4">
            <v-img
              size="small"
              width="220px"
              height="220px"
              :src="require('@/assets/svgs/email-2.svg')"
            ></v-img>
          </div>

          <v-card-actions class="mt-n9">
            <v-col>
              <v-row class="mb-3">
                <v-btn
                  block
                  class="btn white--text mt-0 mb-4"
                  style="border-radius: 8px !important"
                  to="/items/new"
                  @click="listingDialog = false"
                  color="accent"
                >
                  <v-icon x-small class="mr-1">fas fa-plus</v-icon>Add Rental
                  Item
                </v-btn>
              </v-row>
              <v-divider class="my-4"></v-divider>
              <v-row class="px-10">
                <div style="font-size: 0.6rem" class="mb-0 pr-1 mb-2">
                  Interested in a safer and easier buy/sell experience? Get
                  early access
                </div>
                <v-btn
                  block
                  class="mt-1 mb-4 btn white--text"
                  style="border-radius: 8px !important"
                  to="/sell/new"
                  color="#8F9CF8"
                >
                  <v-badge
                    inline
                    class="white--text mt-0"
                    color="accent"
                    content="new"
                    style="
                      border-radius: 8px !important;
                      color: white !important;
                    "
                  >
                    Sell with Strapp
                  </v-badge>
                </v-btn>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      v-model="sellDialog"
      max-width="450px"
      transition="dialog-bottom-transition"
    >
      <template>
        <v-card
          style="padding: 0px 24px !important; border-radius: 12px !important"
        >
          <v-card-title
            style="
              padding: 0px 24px !important;
              font-size: 1.5rem !important;
              line-height: 1.43;
            "
            class="text-center black--text"
          >
            <p class="my-3 ml-auto mr-auto">Early Access</p>
          </v-card-title>
          <v-card-text
            style="
              font-size: 16px !important;
              line-height: 20px !important;
              color: rgb(34, 34, 34) !important;
            "
            class="mt-2 pa-0 text-center"
          >
            We are in the final stages of putting together our Strapp Buy/Sell
            offering! By completing this form you will get early access to our
            brand new marketplace!
          </v-card-text>
          <!-- <p style=" padding-top: 12px">Let us know what you'd want to buy or sell on Strapp</p> -->
          <v-textarea
            v-model="sellComment"
            placeholder="Let us know what you'd want to buy or sell on Strapp, as well as any other questions you might have."
            style="padding-top: 24px"
            color="rgb(34, 34, 34)"
            type="text"
            outlined
            class="round"
          >
            <!--     <div
                class="input-group-addon"
                v-text="(max - itemDescription.length)"
              /> -->
          </v-textarea>
          <v-checkbox
            class="mt-0 mb-4"
            v-model="priority"
            label="I want early access to Strapp Buy/Sell"
            color="accent"
            hide-details
          >
          </v-checkbox>
          <v-btn
            block
            class="mt-1 mb-4 btn white--text"
            style="border-radius: 8px !important"
            @click="getPriorityAccess()"
            color="accent"
            :disabled="!priority"
          >
            Get Early Access
          </v-btn>

          <v-card-actions class="mt-n9">
            <v-col>
              <v-row class="mb-3">
                <!-- <v-btn
              block
              class="btn white--text mt-0"
              style="border-radius: 8px !important"
             to="new/item"
              color="#8F9CF8"
            >
              Rent with Strapp
            </v-btn> -->
              </v-row>
              <v-row> </v-row>
            </v-col>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-system-bar
      v-if="this.$route.name == 'Home 🏠'"
      height="78px"
      fixed
      class="align-center banner"
      style="z-index: 4"
      window
    >
      <v-col class="grid mx-n12">
        <div
          class="text-caption white--text text-sm-body-2 text-md-h6 font-weight-bold"
        >
          Now Introducing, buy/sell with Strapp
        </div>
        <div class="white--text hidden-sm-and-down">
          A Safer, Easier and Faster way to buy and sell second hand to others
          in your community.
        </div>
        <v-btn
          id="earlyaccess"
          small
          class="mx-3 original hidden-md-and-up"
          rounded
          elevation="6"
          href="https://strapp.co.za/"
        >
          <p class="mt-4">
            Take me there
            <v-icon small class="ml-1 mr-n1">mdi-open-in-new</v-icon>
          </p>
        </v-btn>
      </v-col>
      <v-btn
        id="earlyaccess"
        small
        class="hidden-sm-and-down mx-3 original"
        rounded
        elevation="6"
        href="https://strapp.co.za/"
      >
        <p class="mt-4">
          Take me there<v-icon small class="ml-1 mr-n1">mdi-open-in-new</v-icon>
        </p>
      </v-btn>
      <v-icon>mdi-x-mark</v-icon>
    </v-system-bar>

    <v-app-bar
      elevate-on-scroll
      v-if="this.$route.name != 'landing' || this.$route.name != 'Purchase'"
      v-scroll="onScroll"
      color="white"
      app
      :style="
        this.$route.name == 'Home 🏠'
          ? 'z-index: 4; margin-top: 78px'
          : 'z-index: 4;'
      "
      height="80px"
    >
      <div
        class="d-flex align-center"
        style="display: flex; justify-content: space-between; width: 100%"
      >
        <div class="d-flex align-center">
          <v-app-bar-nav-icon
            aria-label="Navbar Icon"
            @click="drawer = !drawer"
          >
            <svg
              style="width: 20px; height: 20px"
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="bars"
              class="svg-inline--fa fa-bars fa-w-14"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="#8531A9"
                  d="M448 256c0 17.67-14.33 32-31.1 32H31.1C14.33 288 0 273.7 0 256s14.33-32 31.1-32h384C433.7 224 448 238.3 448 256z"
                ></path>
                <path
                  class="fa-primary"
                  fill="currentColor"
                  d="M416 384H31.1C14.33 384 0 398.3 0 415.1S14.33 448 31.1 448h384C433.7 448 448 433.7 448 416S433.7 384 416 384zM416 64H31.1C14.33 64 0 78.33 0 95.1S14.33 128 31.1 128h384C433.7 128 448 113.7 448 96S433.7 64 416 64z"
                ></path>
              </g>
            </svg>
          </v-app-bar-nav-icon>

          <router-link aria-label="Home Logo" to="/">
            <v-img
              width="100px"
              :src="require('@/assets/logos/logo1.svg')"
              contain
              class="hidden-sm-and-down"
              aria-label="Home Logo"
              alt-text="Home Logo"
            />
            <v-img
              width="30px"
              :src="require('@/assets/logos/icon1.svg')"
              contain
              class="py-4 hidden-md-and-up"
            />
          </router-link>
        </div>

        <!-- <p>{{ this.$store.state.user }}</p> -->

        <div class="d-flex align-center">
          <!-- <v-btn
            class="mr-3 hidden-sm-and-down appbutton white--text font-weight-medium"
            color="#B22AF0"
            rounded
            elevation="6"
            @click="log()"
            z-index="12"
          >
            <v-icon>mdi-google-circles-communities</v-icon>
            communities</v-btn
          > -->
          <v-btn
            class="mr-3 hidden-sm-and-down appbutton white--text font-weight-medium"
            color="#B22AF0"
            rounded
            elevation="6"
            @click="listingDialog = true"
            z-index="12"
          >
            <v-icon x-small class="mr-1">fas fa-plus</v-icon>Add Item</v-btn
          >

          <div>
            <v-btn
              elevation="6"
              class="appbutton white--text font-weight-medium mr-3"
              rounded
              to="/items"
              color="#B22AF0"
              z-index="12"
            >
              <v-img
                class="mr-2"
                :style="
                  $vuetify.breakpoint.xsOnly
                    ? 'height: 10px; width: 10px;'
                    : '' && $vuetify.breakpoint.smAndDown
                    ? 'height: 15px; width: 15px;'
                    : 'height: 15px; width: 15px;' &&
                      $vuetify.breakpoint.mdAndUp
                    ? 'height: 15px; width: 15px;'
                    : 'height: 12px; width: 12px;'
                "
                :src="
                  require('@/assets/fontawesome/magnifying-glass-solid.svg')
                "
              />Browse</v-btn
            >
          </div>

          <v-menu
            style="z-index: 11 !important; border-radius: 12px"
            class="list"
            offset-y
            transition="slide-y-transition"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="[attrs]"
                v-on="on"
                rounded
                elevation="6"
                class="white app--text font-weight-medium mr-2"
                z-index="12"
              >
                <v-img
                  :style="
                    $vuetify.breakpoint.xsOnly
                      ? 'height: 10px; width: 10px;'
                      : '' && $vuetify.breakpoint.smAndDown
                      ? 'height: 30px; width: 30px;'
                      : 'height: 30px; width: 30px;' &&
                        $vuetify.breakpoint.mdAndUp
                      ? 'height: 18px; width: 18px;'
                      : 'height: 12px; width: 12px;'
                  "
                  :src="require('@/assets/fontawesome/bars-duotone.svg')"
                  contain
                />
                <v-btn
                  elevation="0"
                  :class="$vuetify.breakpoint.mdAndUp ? 'ml-3 mr-n2' : 'mr-n3 '"
                  color="transparent"
                  fab
                  aria-label="Profile NavIcon"
                  x-small
                >
                  <v-avatar outline size="30" class="ma-3">
                    <!-- <v-img v-if="avatar !== null" :src="avatar"></v-img> -->

                    <svg
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                      style="fill: currentcolor"
                      aria-hidden="true"
                      role="presentation"
                      focusable="false"
                    >
                      <path
                        d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                      ></path>
                    </svg>
                  </v-avatar>
                </v-btn>
              </v-btn>
            </template>

            <v-card
              class="list"
              width="180px"
              style="z-index: 11 !important; border-radius: 12px"
            >
              <v-list class="list" dense>
                <v-list-item-group>
                  <v-list-item
                    v-if="user === null"
                    @click.stop="signupDialog = true"
                  >
                    <p class="mb-n2 mt-n2 caption">
                      <v-icon x-small class="mr-2">fas fa-user-plus</v-icon>Sign
                      Up
                    </p>
                  </v-list-item>

                  <v-list-item
                    v-if="user === null"
                    @click.stop="loginDialog = true"
                  >
                    <p class="mb-n2 mt-n2 caption">
                      <v-icon x-small class="mr-2">fas fa-unlock</v-icon>
                      Login
                    </p>
                  </v-list-item>
                  <v-list-item to="/items/new" id="right-nav-add-item">
                    <p class="mb-n2 mt-n2 caption">
                      <v-icon x-small class="mr-2">fas fa-plus</v-icon>
                      Add an Item
                    </p>
                  </v-list-item>
                  <v-list-item id="right-nav-new-request" to="/new/request">
                    <p class="mb-n2 mt-n2 caption">
                      <v-icon x-small class="mr-2">fas fa-question</v-icon>
                      Request an Item
                    </p>
                  </v-list-item>

                  <div>
                    <v-divider v-if="user !== null"></v-divider>
                    <v-list-item
                      v-if="user !== null"
                      to="/dashboard"
                      id="right-nav-dashboard"
                    >
                      <p class="mb-n2 mt-n2 caption">
                        <v-icon x-small class="mr-2"
                          >fas fa-tachometer-alt</v-icon
                        >
                        Dashboard
                      </p>
                    </v-list-item>
                    <v-divider v-if="user !== null"></v-divider>
                    <v-list-item
                      v-if="user !== null"
                      :to="'/profile/' + this.$store.getters.user.id"
                      id="right-nav-dashboard"
                    >
                      <p class="mb-n2 mt-n2 caption">
                        <v-icon x-small class="mr-2">fas fa-user-alt</v-icon>
                        My Profile
                      </p>
                    </v-list-item>
                    <v-divider v-if="user !== null"></v-divider>
                    <v-list-item
                      v-if="$store.getters.loadedRooms && user !== null"
                      @click="toInbox()"
                    >
                      <v-badge
                        :value="inbox > 0 === true"
                        color="#b22af0"
                        :content="inbox"
                      >
                        <p class="mb-n2 mt-n2 caption pr-2">
                          <v-icon x-small class="mr-2">fas fa-inbox</v-icon>
                          Inbox
                        </p></v-badge
                      >
                    </v-list-item>
                    <v-divider v-if="user !== null"></v-divider>
                    <v-list-item v-if="user !== null" @click="onLogout">
                      <p class="mb-n2 mt-n2 caption">
                        <v-icon x-small class="mr-2"
                          >fas fa-sign-out-alt</v-icon
                        >
                        Log Out
                      </p>
                    </v-list-item>
                  </div>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-menu>
        </div>
      </div>
    </v-app-bar>

    <v-dialog
      v-model="signupDialog"
      scrollable
      :overlay="false"
      max-width="568px"
      transition="dialog-transition"
    >
      <SignupComponent
        :shouldRedirect="redirect"
        :addItem="false"
        @loggedIn="signupDialog = false"
        :fromPage="true"
        @changeDialog="
          signupDialog = false;
          loginDialog = true;
        "
        ><v-icon @click="signupDialog = false" class="exit"
          >mdi-close</v-icon
        ></SignupComponent
      >
    </v-dialog>

    <v-dialog
      v-model="loginDialog"
      scrollable
      :overlay="false"
      max-width="568px"
      transition="dialog-transition"
    >
      <LoginComponent
        :shouldRedirect="redirect"
        :fromPage="true"
        :addItem="false"
        @loggedIn="loginDialog = false"
        @changeDialog="
          loginDialog = false;
          signupDialog = true;
        "
      />
    </v-dialog>

    <home-drawer v-model="drawer" :items="items" />
  </div>
</template>

<style>
.list {
  background: rgb(255, 255, 255) !important;
  border-radius: 12px !important;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 16px !important;
  color: rgb(34, 34, 34) !important;
  z-index: 11 !important;
}

.grid {
  display: grid;
  place-items: center;
}

.appbutton {
  font-weight: 700;
  transition: 0.5s;
  box-shadow: #b22af0 0px 5px 15px;
  background: rgb(247, 150, 192);
  background: radial-gradient(circle, #b22af0 0%, #6db2e3 100%);
  transition: all 0.3s ease 0s;
}

.appbuttonSecondary {
  font-weight: 700;
  transition: 0.5s;
  box-shadow: #b22af0 0px 5px 15px;
  background: rgb(247, 150, 192);
  background: radial-gradient(circle, #f08455 0%, #f8b58e 100%);
  transition: all 0.3s ease 0s;
}

.f25 {
  font-size: 25px;
}

.ancher-bottom {
  position: absolute;
  bottom: 15px;
}

.appbutton:hover {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
  transform: translateY(-7px);
}

.appbuttonSecondary:hover {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
  transform: translateY(-7px);
}

.banner {
  box-shadow: #b22af0 0px 5px 15px;
  background: rgb(247, 150, 192);
  background: radial-gradient(circle, #b22af0 0%, #6db2e3 100%);
}
</style>
